import { render } from "./reuseStandardDialog.vue?vue&type=template&id=ab1ab224"
import script from "./reuseStandardDialog.vue?vue&type=script&lang=js"
export * from "./reuseStandardDialog.vue?vue&type=script&lang=js"

import "./reuseStandardDialog.vue?vue&type=style&index=0&id=ab1ab224&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__